import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AdminSignup = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { signup, signInWithGoogleAsAdmin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!fullName || !email || !password || !confirmPassword) {
      setError('Please fill out all required fields.');
      return;
    }
    
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    
    if (password !== confirmPassword) {
      return setError('Passwords do not match');
    }

    try {
      setError('');
      setLoading(true);
      
      // Create admin account with admin role
      await signup(email, password, {
        fullName,
        role: 'admin', // Set role as admin
        isAdmin: true,
        createdAt: new Date()
      });
      
      navigate('/admin');
    } catch (error) {
      setError('Failed to create admin account: ' + error.message);
    }
    
    setLoading(false);
  };

  const handleGoogleSignup = async () => {
    try {
      setError('');
      setLoading(true);
      await signInWithGoogleAsAdmin();
      navigate('/admin');
    } catch (error) {
      setError('Failed to sign up with Google: ' + error.message);
    }
    setLoading(false);
  };

  return (
    <div className="modern-auth-container">
      <div className="modern-auth-card signup-card">
        <div className="auth-logo-section">
          <div className="auth-logo">
            <img 
              src="/logo.png" 
              alt="Paradise Landscaping Logo" 
              className="auth-logo-image"
            />
          </div>
          <h1 className="modern-auth-title">Admin Registration</h1>
          <p className="auth-subtitle">Create your administrator account</p>
        </div>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="modern-form-group">
            <label className="modern-form-label">Full Name *</label>
            <div className="input-with-icon">
              <span className="input-icon">👤</span>
              <input
                type="text"
                className="modern-form-input"
                placeholder="Enter your full name"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="modern-form-group">
            <label className="modern-form-label">Admin Email Address *</label>
            <div className="input-with-icon">
              <span className="input-icon">📧</span>
              <input
                type="email"
                className="modern-form-input"
                placeholder="Enter your admin email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>



          <div className="modern-form-group">
            <label className="modern-form-label">Password *</label>
            <div className="input-with-icon">
              <span className="input-icon">🔒</span>
              <input
                type={showPassword ? "text" : "password"}
                className="modern-form-input"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            <small className="field-hint">Password must be at least 6 characters</small>
          </div>

          <div className="modern-form-group">
            <label className="modern-form-label">Confirm Password *</label>
            <div className="input-with-icon">
              <span className="input-icon">🔐</span>
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="modern-form-input"
                placeholder="Confirm your password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <button 
            type="submit" 
            className="modern-btn-primary admin-btn"
            disabled={loading}
          >
            {loading ? 'Creating Admin Account...' : 'Create Admin Account'}
          </button>
        </form>

        <div className="auth-divider">
          <span>OR</span>
        </div>

        <button 
          onClick={handleGoogleSignup}
          className="google-btn"
          disabled={loading}
        >
          <span className="google-icon">🔍</span>
          Continue with Google
        </button>

        <div className="auth-footer">
          Already have admin account? <Link to="/admin/login" className="auth-link">Sign in here</Link>
        </div>

        <div className="auth-footer" style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #e5e7eb' }}>
          Customer portal: <Link to="/signup" className="auth-link">Customer Registration</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminSignup;
